<template>
  <b-card class="border rounded-xl border-gray-200 mb-3">
    <div class="mb-2 pb-1 border-b">
      <div class="font-semibold text-[#333333]">
        Ubah Massal
      </div>
      <div class="text-xs md:text-sm text-[#828282]">
        Pilih 2 produk atau lebih untuk ubah massal
        <span
          v-if="selectedCount > 0"
          class="text-[#F95031] font-medium"
        >
          ({{ selectedCount }} produk dipilih)
        </span>
      </div>
    </div>

    <div class="flex flex-col lg:flex-row items-end gap-3">
      <!-- Jenis Diskon -->
      <b-form-group
        class="flex-1 mb-0 w-full"
        label-for="bulk-discount-type"
        label-class="font-medium text-[#333333] mb-0.5"
      >
        <template #label>
          Jenis Diskon<span class="text-danger">*</span>
        </template>
        <v-select
          id="bulk-discount-type"
          v-model="localForm.discountType"
          :options="discountTypeOptions"
          :reduce="item => item.value"
          label="label"
          placeholder="Pilih Jenis Diskon"
          :clearable="false"
          class="custom-bulk-select"
          @input="$emit('update:discount-type', $event)"
        />
      </b-form-group>

      <!-- Nominal Diskon -->
      <b-form-group
        class="flex-1 mb-0 w-full"
        label-for="bulk-discount-value"
        label-class="font-medium text-[#333333] mb-0.5"
      >
        <template #label>
          Nominal Diskon<span class="text-danger">*</span>
        </template>
        <b-input-group
          :prepend="localForm.discountType === 'nominal' ? 'Rp' : ''"
          :append="localForm.discountType !== 'nominal' ? '%' : ''"
          class="custom-bulk-group"
        >
          <b-form-input
            id="bulk-discount-value"
            v-model="localForm.discountValue"
            type="number"
            min="0"
            :max="localForm.discountType === 'percentage' ? 100 : undefined"
            placeholder="0"
            :formatter="formatPositiveNumber"
          />
        </b-input-group>
      </b-form-group>

      <!-- Minimum Transaksi -->
      <b-form-group
        class="flex-1 mb-0 w-full"
        label-for="bulk-min-transaction"
        label-class="font-medium text-[#333333] mb-0.5"
      >
        <template #label>
          Minimum Transaksi<span class="text-danger">*</span>
        </template>
        <b-input-group
          prepend="Rp"
          class="custom-bulk-group"
        >
          <b-form-input
            id="bulk-min-transaction"
            v-model="localForm.minTransaction"
            type="number"
            min="0"
            placeholder="0"
            :formatter="formatPositiveNumber"
          />
        </b-input-group>
      </b-form-group>

      <!-- Tombol -->
      <b-button
        variant="primary"
        class="whitespace-nowrap custom-bulk-btn"
        :disabled="selectedCount < 2"
        @click="onSubmit"
      >
        Ubah Massal
      </b-button>
    </div>
  </b-card>
</template>

<script>
import VSelect from 'vue-select'

export default {
  components: {
    VSelect,
  },
  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
    discountType: {
      type: String,
      default: 'percentage',
    },
  },
  data() {
    return {
      localForm: {
        discountType: this.discountType,
        discountValue: null,
        minTransaction: null,
      },
      discountTypeOptions: [
        { label: 'Persentase', value: 'percentage' },
        { label: 'Nominal', value: 'nominal' },
      ],
    }
  },
  watch: {
    discountType: {
      handler(val) {
        this.localForm.discountType = val
      },
      immediate: true,
    },
    'localForm.discountType': {
      handler(val) {
        if (val === 'percentage' && this.localForm.discountValue > 100) {
          this.localForm.discountValue = 100
        }
      },
    },
  },
  methods: {
    formatPositiveNumber(value) {
      if (value === '' || value === null || value === undefined) return value
      return String(value).replace(/[^0-9]/g, '')
    },
    onSubmit() {
      this.$emit('submit', { ...this.localForm })
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.custom-bulk-select {
  .vs__dropdown-toggle {
    min-height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #E2E8F0 !important;
    padding: 0 0.5rem !important;
    align-items: center;
  }

  .vs__selected {
    color: #1E293B !important;
    font-size: 0.875rem !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  &.vs--open .vs__dropdown-toggle {
    border-color: #F97316 !important;
    box-shadow: 0 0 0 1px rgba(249, 115, 22, 0.2) !important;
  }
}

.custom-bulk-group {
  .input-group-prepend .input-group-text {
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
    border: 1px solid #E2E8F0 !important;
    border-right: none !important;
    background-color: #F8FAFC;
    color: #64748B;
  }
  .input-group-append .input-group-text {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    border: 1px solid #E2E8F0 !important;
    border-left: none !important;
    background-color: #F8FAFC;
    color: #64748B;
  }
  .form-control {
    height: 40px !important;
    border: 1px solid #E2E8F0 !important;
    color: #1E293B !important;
    font-size: 0.875rem !important;

    &:first-child {
      border-top-left-radius: 8px !important;
      border-bottom-left-radius: 8px !important;
    }
    &:last-child {
      border-top-right-radius: 8px !important;
      border-bottom-right-radius: 8px !important;
    }

    &:focus {
      border-color: #F97316 !important;
      box-shadow: 0 0 0 1px rgba(249, 115, 22, 0.2) !important;
    }
  }
}

.custom-bulk-btn {
  height: 40px !important;
  border-radius: 8px !important;
}
</style>
